<template>
  <div class="custom-form-attribute">
    <el-tabs v-model="activeName" stretch>
      <el-tab-pane :label="$t('81bf5ae1')" name="first"></el-tab-pane>
      <!-- <el-tab-pane :label="$t('96471c83')" name="second" disabled></el-tab-pane> -->
    </el-tabs>
    <div class="custom-component-list">
      <!-- 组件分组 -->
      <div class="custom-component-group" v-for="item in control" :key="item.groupName">
        <!-- 分组标题 -->
        <p class="component-title">{{ $t(item.groupName) }}<br /></p>
        <!-- 组件列表 -->
        <div class="custom-component-wrap">
          <div
            class="component-item"
            v-for="el in item.list"
            :key="el.name"
            draggable="true"
            @dragstart="event => handleDragStart(event, el.type)"
          >
            <span class="iconfont component-logo" :class="el.icon"></span>
            <span class="component-name">{{ $t(el.name) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { control } from '../enum'
export default {
  data() {
    return {
      activeName: 'first',
      // 组件列表
      control
    }
  },
  methods: {
    // 开始拖拽
    // @param Event对象 和 type当前组件对象
    handleDragStart(event, type) {
      // console.log(event, type)
      event.dataTransfer.setData('type', type)
    }
  }
}
</script>

<style></style>
